<div class="vehicle-form op-mt-10" *transloco="let t">
	<div mat-dialog-title *ngIf="dialogData.vinResults">
		<div class="op-right op-mb-8">
			<button
				mat-icon-button
				id="messageDialogCloseBtn"
				[mat-dialog-close]="false"
				(click)="reloadPage()"
				aria-label="{{ t('GLOBAL.close') }}"
			>
				<mat-icon svgIcon="op-close"></mat-icon>
			</button>
		</div>
	</div>
	<form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
		<div class="op-header-1-font op-mb-12" *ngIf="dialogData.vinResults">{{ t('VEHICLE.confirmVehicle') }}</div>
		<div *ngIf="vinResults" class="vehicle-details">
			<mat-form-field appearance="none">
				<div class="vehicle-details-row">
					<mat-label>{{ t('VEHICLE.year') }}</mat-label>
					<div class="op-black-bold input-text">
						<input matInput type="text" formControlName="year" readonly />
					</div>
				</div>
				<mat-error id="yearError" *ngIf="formGroup.controls['year'].invalid">
					<mat-icon svgIcon="op-attention"></mat-icon>
					{{ t('VEHICLE.vehicleYearsErrMsg') }}
				</mat-error>
			</mat-form-field>
			<mat-form-field appearance="none">
				<div class="vehicle-details-row">
					<mat-label>{{ t('VEHICLE.make') }}</mat-label>
					<div class="op-black-bold input-text">
						<input matInput type="text" formControlName="makeStr" readonly />
					</div>
				</div>
				<mat-error id="makeIdError" *ngIf="formGroup.controls['makeId'].invalid">
					<mat-icon svgIcon="op-attention"></mat-icon>
					{{ t('VEHICLE.vehicleTypeErrMsg') }}
				</mat-error>
			</mat-form-field>

			<mat-form-field appearance="none">
				<div class="vehicle-details-row">
					<mat-label>{{ t('VEHICLE.model') }}</mat-label>
					<div class="op-black-bold input-text">
						<input matInput type="text" formControlName="modelStr" readonly />
					</div>
				</div>
				<mat-error id="modelIdError" *ngIf="formGroup.controls['modelId'].invalid">
					<mat-icon svgIcon="op-attention"></mat-icon>
					{{ t('VEHICLE.vehicleTypeErrMsg') }}
				</mat-error>
			</mat-form-field>

			<mat-form-field appearance="none">
				<div class="vehicle-details-row">
					<mat-label>{{ t('VEHICLE.trim') }}</mat-label>
					<div class="op-black-bold input-text">
						<input matInput type="text" formControlName="trimStr" readonly />
					</div>
				</div>
				<mat-error id="trimIdError" *ngIf="formGroup.controls['trimId'].invalid">
					<mat-icon svgIcon="op-attention"></mat-icon>
					{{ t('VEHICLE.vehicleTypeErrMsg') }}
				</mat-error>
			</mat-form-field>
		</div>

		<div class="op-body-1-font op-mt-5 op-mb-5" *ngIf="!inValidVehicle">
			{{ t('VEHICLE.notYourVehicle') }}
			<a mat-flat-button color="link-md" id="notYourVehicle" (click)="reloadPage()">
				{{ t('VEHICLE.clickHere') }}
			</a>
		</div>

		<mat-form-field class="form-element" appearance="outline">
			<mat-label>{{ t('VEHICLE.mileage') }}</mat-label>
			<input
				matInput
				type="text"
				inputmode="numeric"
				name="odometer"
				maxlength="8"
				id="odometer"
				formControlName="odometer"
				mask="separator"
				thousandSeparator=","
				trackInputValue="true"
				(blur)="onMileageBlurEvent()"
				required
			/>
			<mat-error
				id="odometerError"
				*ngIf="formGroup.controls['odometer'].invalid && formGroup.controls['odometer'].touched"
			>
				<mat-icon svgIcon="op-attention"></mat-icon>
				{{ t('VEHICLE.mileageErrorText') }}
			</mat-error>
			<mat-hint>{{ t('VEHICLE.mileageHint') }}</mat-hint>
		</mat-form-field>

		<div *ngIf="inValidVehicle" class="vehicle-invalid op-mt-20">
			<div class="op-mt-10">
				<div class="vehicle-invalid-details">
					<mat-icon svgIcon="op-attention"></mat-icon>
					<div class="op-ml-5 op-black-bold">
						{{ t('VEHICLE.notEligible') }}
					</div>
				</div>
			</div>
			<div class="op-mt-10">
				<div class="vehicle-invalid-details">
					<div class="op-ml-10 vehicle-invalid-another">
						<div>
							{{ t('VEHICLE.anotherVehicle') }}
						</div>
						<div class="vehicle-invalid-try-now">
							<div class="op-black-bold">
								<a
									href=""
									onclick="return false"
									class=""
									id="tryNow"
									[opTagClick]="'try another vehicle'"
									(click)="reloadPage()"
								>
									{{ t('VEHICLE.tryNow') }}
								</a>
							</div>
							<mat-icon svgIcon="op-caretRightSmall"></mat-icon>
						</div>
					</div>
				</div>
			</div>
			<div class="op-mt-10" *ngIf="!hasSPLOnly">
				<div class="vehicle-invalid-details">
					<div class="op-ml-10 vehicle-invalid-another">
						<div>
							{{ t('VEHICLE.onlyPersonalOffer') }}
						</div>
						<div class="vehicle-invalid-try-now">
							<div class="op-black-bold">
								<a
									href=""
									onclick="return false"
									class=""
									id="continue"
									[opTagClick]="'returnToOffers'"
									(click)="returnToOffers()"
								>
									{{ t('GLOBAL.continue') }}
								</a>
							</div>
							<mat-icon svgIcon="op-caretRightSmall"></mat-icon>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="op-center op-mt-20">
			<button
				mat-flat-button
				color="primary"
				type="submit"
				[opTagClick]="'form check eligibility'"
				[disabled]="formGroup.invalid"
			>
				{{ t('VEHICLE.btn_check_eligibility') }}
			</button>
		</div>
		<div *ngIf="dialogData.vinResults" class="op-center op-mt-20">
			<button
				mat-flat-button
				color="secondary"
				id="returnToOffersBtn"
				type="button"
				(click)="returnToOffers()"
				[opTagClick]="'returnToOffers'"
			>
				{{ t('VEHICLE.btn_explore_later') }}
			</button>
		</div>
	</form>
</div>
